import React from 'react';
import { StyledAvatar } from './style';

const Avatar = ({ ...rest }) => {
  return <StyledAvatar {...rest} />;
};

export default Avatar;
